export function calculateInnovationSupport(marketValue: number, deductible: number) {
  return marketValue - deductible;
}

export function calculateSupportIntensity(marketValue: number, deductible: number) {
  return Math.round(((marketValue - deductible) / marketValue) * 100);
}
